/**
 * VelorHR Administration - premium theme.
 * Brand-matched to the VelorHR customer app: the same VelorHR green (#599c16)
 * and Roboto typeface, elevated with a sophisticated graphite sidebar, a cool
 * near-white workspace, and layered depth. One sans (Roboto).
 */
const BRAND = '#599c16'; // VelorHR brand green (matches app.velorhr.com)
const BRAND_BRIGHT = '#6cb61b';

const FONT =
  "Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif";

const theme = {
  token: {
    colorPrimary: BRAND,
    colorInfo: BRAND,
    colorSuccess: '#599c16',
    colorWarning: '#f79009',
    colorError: '#f04438',
    colorLink: BRAND,
    colorLinkHover: BRAND_BRIGHT,

    colorTextBase: '#101828',
    colorText: '#344054',
    colorTextSecondary: '#667085',
    colorTextTertiary: '#98a2b3',

    colorBorder: '#e6ecd9',
    colorBorderSecondary: '#eef3e3',
    colorBgLayout: '#f6fbed',
    colorBgContainer: '#ffffff',
    colorBgElevated: '#ffffff',

    borderRadius: 8,
    borderRadiusLG: 12,
    borderRadiusSM: 6,

    fontFamily: FONT,
    fontSize: 14,
    controlHeight: 40,

    boxShadow: '0 1px 2px rgba(16,24,40,0.06), 0 1px 3px rgba(16,24,40,0.10)',
    boxShadowSecondary: '0 4px 8px -2px rgba(16,24,40,0.10), 0 2px 4px -2px rgba(16,24,40,0.06)',
    wireframe: false,
  },
  components: {
    Layout: {
      headerBg: '#f6fbed',
      headerHeight: 64,
      headerPadding: '0 24px',
      siderBg: '#f6fbed',
      bodyBg: '#f6fbed',
    },
    Menu: {
      itemBg: 'transparent',
      subMenuItemBg: 'transparent',
      popupBg: '#ffffff',
      itemColor: '#475467',
      itemHoverBg: '#eef7e0',
      itemHoverColor: '#206d1a',
      itemSelectedBg: BRAND,
      itemSelectedColor: '#ffffff',
      itemActiveBg: '#eef7e0',
      groupTitleColor: '#98a2b3',
      itemBorderRadius: 8,
      itemMarginInline: 10,
      itemHeight: 42,
      iconSize: 18,
      fontSize: 14,
    },
    Button: {
      controlHeight: 40,
      controlHeightLG: 44,
      fontWeight: 600,
      primaryShadow: '0 1px 2px rgba(16,24,40,0.10)',
      defaultShadow: 'none',
      borderRadius: 8,
    },
    Card: {
      borderRadiusLG: 14,
      colorBorderSecondary: '#eaecf0',
      paddingLG: 20,
      boxShadowTertiary: '0 1px 2px rgba(16,24,40,0.05), 0 1px 3px rgba(16,24,40,0.08)',
    },
    Table: {
      headerBg: '#f9fafb',
      headerColor: '#667085',
      headerSplitColor: 'transparent',
      borderColor: '#f0f1f4',
      rowHoverBg: '#f9fafb',
      cellPaddingBlock: 14,
      fontWeightStrong: 600,
    },
    Input: { controlHeight: 40, borderRadius: 8, paddingBlock: 8, activeShadow: '0 0 0 3px rgba(89,156,22,0.12)' },
    InputNumber: { controlHeight: 40, borderRadius: 8 },
    Select: { controlHeight: 40, borderRadius: 8 },
    DatePicker: { controlHeight: 40, borderRadius: 8 },
    Modal: { borderRadiusLG: 16, paddingContentHorizontalLG: 24 },
    Tag: { borderRadiusSM: 16, defaultBg: '#f2f4f7', defaultColor: '#344054' },
    Statistic: { titleFontSize: 13, contentFontSize: 30 },
    Segmented: { borderRadius: 8, itemSelectedBg: '#ffffff' },
    Breadcrumb: { separatorColor: '#98a2b3', linkColor: '#667085', lastItemColor: '#101828' },
  },
};

export default theme;
